import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	preview: {
		paddingBlock: token('space.075'),
		paddingInline: token('space.150'),
		backgroundColor: token('color.background.selected'),
		borderColor: token('color.border.selected'),
		borderStyle: 'solid',
		borderWidth: token('border.width'),
		borderRadius: token('radius.full'),
		color: token('color.text.selected'),
		font: token('font.body'),
		fontWeight: token('font.weight.medium'),
		whiteSpace: 'nowrap',
		maxWidth: '248px',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		boxShadow: token('elevation.shadow.raised'),
	},
});

type TabDragPreviewProps = {
	title: string;
};

/**
 * `TabDragPreview` — a lightweight pill clone rendered inside the native drag preview portal.
 * Mirrors the visual appearance of a `TabPill` without any interactive behaviour.
 */
export const TabDragPreview = ({ title }: TabDragPreviewProps): React.JSX.Element => {
	return <Box xcss={styles.preview}>{title}</Box>;
};
